import React, { useEffect, useState } from "react";
import Select from "react-select";

function convertToSelectOptions(objects, labelKey, considerValue) {
  return objects.map((obj) => ({
    ...obj,
    value: obj[considerValue],
    label: obj[labelKey]
  }));
}

function removeValueAndLabelKeys(objects) {
  // eslint-disable-next-line no-unused-vars
  return objects.map(({ value, label, ...rest }) => rest);
}

const MultiselectDropdown = ({
  options,
  selectedData,
  callbackfunction,
  displayValue = "name",
  considerValue = "id",
  isMulti = true,
  label
}) => {
  const [newOptions, setNewOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const handleChangeOptions = (data) => {
    setSelected(data);
    const newData = removeValueAndLabelKeys(data);
    callbackfunction(newData);
  };

  useEffect(() => {
    const newData = convertToSelectOptions(options, displayValue, considerValue);
    const newSelectedData = convertToSelectOptions(selectedData, displayValue, considerValue);
    setNewOptions(newData);
    setSelected(newSelectedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, selectedData]);

  return (
    <>
      {label && <label className="builder_label">{label}</label>}
      <Select
        value={selected}
        onChange={handleChangeOptions}
        options={newOptions}
        isMulti={isMulti}
        closeMenuOnSelect={isMulti ? false : true}
      />
    </>
  );
};

export default MultiselectDropdown;
